import axios from 'axios'
import type {
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
  AxiosRequestConfig,
} from 'axios'
import { getToken, removeToken } from '../utils/auth'
import { ElMessage } from 'element-plus'
import router from '@/router'

const baseURL = '/fznapi' // 测试地址
// const baseURL = 'http://192.168.2.110:8090' // 测试地址

const service = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 5 * 1000,
})

// 请求拦截
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken()
    if (token) config.headers.Authorization = token

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  (response: AxiosResponse) => {
    // 未设置状态码则默认成功状态
    const code = response.data.code || 200

    // 获取错误信息
    const msg = response.data.msg || '未知错误,请联系相关人员!'

    if (code === 200) {
      return response.data
    } else if (code === 401) {
      removeToken()
      router.push('/login')
    } else {
      ElMessage.error(msg)
    }
  },
  (error: AxiosError) => {
    let { message } = error
    if (message == 'Network Error') {
      message = '后端接口连接异常'
      80n
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    console.error('requst error => ', message)

    ElMessage.error(message)
    return Promise.reject(error)
  }
)

/**
 * get请求
 * @param url 请求地址
 * @param params 参数
 * @param config 配置参数
 * @returns
 */
export const getRequst = <R>(url: string, params?: any, config?: AxiosRequestConfig) => {
  return service<R, R, typeof params>({
    url,
    method: 'get',
    params,
    ...config,
  })
}

/**
 * post请求
 * @param url 请求地址
 * @param params 参数
 * @param config 配置参数
 * @returns
 */
export const postRequest = <R>(url: string, params?: any, config?: AxiosRequestConfig) => {
  return service<R, R, typeof params>({
    url,
    data: params,
    method: 'post',
    ...config,
  })
}

/**
 * put请求
 * @param url 请求地址
 * @param params 参数
 * @param config 配置参数
 * @returns
 */
export const putRequest = <R>(url: string, params?: any, config?: AxiosRequestConfig) => {
  return service<R, R, typeof params>({
    url,
    data: params,
    method: 'put',
    ...config,
  })
}

/**
 * delete请求
 * @param url 请求地址
 * @param params 参数
 * @param config 配置参数
 * @returns
 */
export const delRequest = <R>(url: string, params?: any, config?: AxiosRequestConfig) => {
  return service<R, R, typeof params>({
    url,
    method: 'delete',
    params,
    ...config,
  })
}

export * from './Api'
export * from "./types"

export default service
